import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";


function App() {
  return (
    <div>
      <Navbar />
      <HomePage />
    </div>
  );
}

export default App;
